import styled from 'styled-components';

type InputPropsT = {
  isError: boolean;
};

export const InputStyled = styled.input<InputPropsT>`
  height: 40px;
  width: 100%;
  padding: 10px;
  border: 1px solid #d0d0d0;
  border-radius: 3px;
  resize: none;

  ${({ theme, isError }) => `
    &:active,
    &:focus {
      border-color: ${theme.primaryColour};
    }

    ${isError ? 'border-color: #ff0000' : ''};

    &:disabled {
      border-color: #d0d0d0;
    }
  `}
`;

export const InputLabelStyled = styled.label`
  display: block;
  margin-bottom: 7px;

  ${({ theme }) => `
    font-weight: ${theme.fontWeights.medium};
  `}
`;

export const FieldWrapperStyled = styled.div`
  position: relative;
`;

export const ErrorMessageStyled = styled.p`
  margin: 0;
  position: absolute;
  color: #ff0000;
`;

export const StarStyled = styled.span`
  color: #ff0000;
`;
